import { Category } from '@/domain/models/content/category'
import { ContentUnsubscribeModel } from '@/domain/models/content/enrollment/unsubscribe/content-unsubscribe-model'
import { UnsubscribeRule } from '@/domain/models/content/enrollment/unsubscribe/unsubscribe-rule'
import { ContentUnsubscribeReasonsResponse } from './content-unsubscribe-service-types'

export const formatContentUnsubscribeReasons = (
  response: ContentUnsubscribeReasonsResponse
): ContentUnsubscribeModel => ({
  name: response.name,
  institutionName: response.institutionName,
  blockPeriodDays: response.blockPeriodDays,
  mustWaitUntilNextMonth: response.mustWaitUntilNextMonth,
  nonRefundableRestrictionEndDate: response.nonRefundableRestrictionEndDate,
  category: Category.getByName(response.categoryType),
  reasons: response.reasons.map(reason => ({
    ...reason,
    rule: UnsubscribeRule.getByName(reason.rule)
  }))
})
